export function stringifyError(maybeError: unknown): string {
  if (maybeError instanceof Error) {
    return JSON.stringify(
      {
        name: maybeError.name,
        message: maybeError.message,
        stack: maybeError.stack,
      },
      null,
      3
    );
  }
  return String(maybeError);
}
